export default __webpack_public_path__ + "static/media/640px-FirstBankofUS00_crop.d611ad10.jpg";